import studentCalendarGetters from '@frontend/store/student/calendar/getters'

export default {
  events(state) {
    return studentCalendarGetters.events(state)
  },
}
